export default __webpack_public_path__ + "static/media/right5.99f29de1.png";